module.exports = __webpack_public_path__ + "static/media/decomposition-thumb.be473ac2.jpg";